// LIST
export const FETCH_SHIFT = "app/SHIFT/FETCH_SHIFT";
export const FETCH_SHIFT_SUCCESS = "app/SHIFT/FETCH_SHIFT_SUCCESS";
export const FETCH_SHIFT_FAILURE = "app/SHIFT/FETCH_SHIFT_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/SHIFT/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/SHIFT/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/SHIFT/GET_VIEW_DATA_FAILURE";
// ADD
export const ADD_SHIFT = "app/SHIFT/ADD_SHIFT";
export const ADD_SHIFT_SUCCESS = "app/SHIFT/ADD_SHIFT_SUCCESS";
export const ADD_SHIFT_FAILURE = "app/SHIFT/ADD_SHIFT_FAILURE";
// EDIT
export const EDIT_SHIFT = "app/SHIFT/EDIT_SHIFT";
export const EDIT_SHIFT_SUCCESS = "app/SHIFT/EDIT_SHIFT_SUCCESS";
export const EDIT_SHIFT_FAILURE = "app/SHIFT/EDIT_SHIFT_FAILURE";
// DELETE
export const DELETE_SHIFT = "app/SHIFT/DELETE_SHIFT";
export const DELETE_SHIFT_SUCCESS = "app/SHIFT/DELETE_SHIFT_SUCCESS";
export const DELETE_SHIFT_FAILURE = "app/SHIFT/DELETE_SHIFT_FAILURE";

export const GET_HISTORY = "app/GET_HISTORY";
export const GET_HISTORY_SUCCESS = "app/GET_HISTORY_SUCCESS";
export const GET_HISTORY_FAILURE = "app/GET_HISTORY_FAILURE";
export const TOGGLE_HISTORY = "app/TOGGLE_HISTORY";
export const TOGGLE_CLOCK_HISTORY = "app/TOGGLE_CLOCK_HISTORY";

export const GET_CLOCK_HISTORY = "app/GET_CLOCK_HISTORY";
export const GET_CLOCK_HISTORY_SUCCESS = "app/GET_CLOCK_HISTORY_SUCCESS";
export const GET_CLOCK_HISTORY_FAILURE = "app/GET_CLOCK_HISTORY_FAILURE";
